import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from '@/pages/home/components/Hero';
import CategoryNav from '@/pages/home/components/CategoryNav';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import ChannelShowcase from '@/pages/home/components/ChannelShowcase';
import PopularSection from '@/pages/home/components/PopularSection';
import NewestSection from '@/pages/home/components/NewestSection';
import CTASection from '@/pages/home/components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <Hero />

        <CategoryNav />

        <FeaturedSection />

        <ChannelShowcase />

        <PopularSection />

        <NewestSection />

        <CTASection />
      </main>

      <Footer />
    </>
  );
}